import { render, staticRenderFns } from "./ModgroupItemsList.vue?vue&type=template&id=2ffc71a3"
import script from "./ModgroupItemsList.vue?vue&type=script&lang=ts"
export * from "./ModgroupItemsList.vue?vue&type=script&lang=ts"
import style0 from "./ModgroupItemsList.vue?vue&type=style&index=0&id=2ffc71a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports